module.exports = __webpack_public_path__ + "static/media/SM-MT-4.92f74da7.mp3";